"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var constants_1 = require("./constants");
var utils = require("./utils");
exports.CLASS_NAME = constants_1.SECTION_BASE_CLASS_NAME;
/**
 * Toolbar section component
 */
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function () {
        return exports.CLASS_NAME;
    };
    Meta.prototype.renderClassValues = function () {
        var align = this.props.align;
        var classes = [];
        if (align != null) {
            classes.push(utils.classNameForSectionAlignment(align));
        }
        return classes;
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var Section = (function (_super) {
    __extends(Section, _super);
    function Section() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Section.prototype.getMetaComponent = function () {
        return Meta;
    };
    Section.prototype.getMetaPropNames = function () {
        return [
            "className",
            "align",
        ];
    };
    Section.prototype.getChildComponent = function () {
        return "section";
    };
    Section.Meta = Meta;
    return Section;
}(base_1.DefaultComponentBase));
exports.default = Section;
//# sourceMappingURL=Section.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/toolbar/lib/Section.js
// module id = ./node_modules/@react-mdc/toolbar/lib/Section.js
// module chunks = 2